<template>
  <modal class="modal--auto-height">
    <div class="modal__stage">
      <div class="modal__head">
        <h5>Playlist</h5>
        <button
          class="button button--icon u-pos-r"
          @click.prevent="closePlaylistModal"
        >
          <i class="icon icon-e-remove" />
        </button>
      </div>
      <div class="modal__body">
        <div class="modal__panel">
          <div class="media-list">
            <div
              v-for="asset in assets"
              :key="asset.id"
              class="media-list__item"
            >
              <div class="form-check u-br">
                <input
                  :id="`asset-${asset.id}`"
                  v-model="form.assets"
                  :value="asset.id"
                  type="checkbox"
                  class="form-check__input"
                >
                <label :for="`asset-${asset.id}`" class="form-check__label" />
              </div>
              <div class="media-list__preview">
                <img :src="asset.thumbnail" alt="">
              </div>
              <div class="media-list__details">
                <div class="data-group">
                  <span class="data data--highlight">{{ asset.name }}</span>
                  <span class="data data--muted">{{ asset.mime_type }}</span>
                  <span class="data data--muted">{{ asset.size | numeral('0.00 b') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__foot">
        <div class="button-group">
          <button
            class="button button--light u-br"
            @click.prevent="$store.dispatch('modal/close')"
          >
            <span class="button__label">Close</span>
          </button>
        </div>
        <div class="button-group u-pos-r">
          <button
            class="button u-br"
            @click.prevent="save"
          >
            Update Playlist
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@components/modals/Modal'

export default {
  name: 'PlaylistModal',
  components: {
    Modal,
  },
  props: {
    playlist: {
      type: Object,
      required: true,
    },
    assets: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      form: this.$inertia.form({
        assets: this.playlist.assets.map(asset => asset.id),
      }),
    }
  },
  methods: {
    async save () {
      await this.form.post(this.route('playlists.assets', this.playlist.id), {
        onStart: () => this.loading = true,
        onFinish: () => this.loading = false,
      })

      this.$store.dispatch('modal/close')
    },
  },
}
</script>
